module.exports = "https://www.gc-qa.gnp.com.mx/667a808da12a7005caec2c52ec1c8905.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/dbk-nwb-alerta.png
// module id = 8092
// module chunks = 0